<template>
  <div>
    <!-- Dialog de pré-visualização -->
    <v-dialog
        v-model="dialogPreview"
        max-width="1000px"
        persistent
        scrollable
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <div class="d-flex align-center">
            <v-avatar size="40" class="mr-3" color="white" elevation="2">
              <v-icon color="primary" size="24">mdi-file-pdf-box</v-icon>
            </v-avatar>
            <div>
              <h3 class="text-h5 font-weight-bold mb-0 white--text">
                {{ tituloRelatorio }}
              </h3>
              <p class="subtitle-1 mb-0 white--text opacity-90">
                Visualização do documento
              </p>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn
              icon
              large
              @click="fecharPreview"
              class="close-btn"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <div class="pdf-container">
            <vue-pdf-embed
                v-if="pdfDataUrl"
                :source="pdfDataUrl + '#toolbar=0&navpanes=0'"
                style="width: 100%; height: 100%; max-width: 985px"
            />
            <div v-else class="d-flex justify-center align-center loading-container">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              />
              <span class="ml-3">Gerando relatório...</span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

<!--          <v-btn-->
<!--              outlined-->
<!--              color="blue darken-2"-->
<!--              @click="imprimirPDF"-->
<!--              :disabled="!pdfDataUrl"-->
<!--          >-->
<!--            <v-icon left>mdi-printer</v-icon>-->
<!--            Imprimir-->
<!--          </v-btn>-->
<!--          <v-btn-->
<!--              dark-->
<!--              color="blue darken-2"-->
<!--              @click="baixarPDF"-->
<!--              :disabled="!pdfDataUrl"-->
<!--          >-->
<!--            <v-icon left>mdi-download</v-icon>-->
<!--            Baixar-->
<!--          </v-btn>-->
          <v-btn
              dark
              color="blue darken-2"
              @click="imprimirPDF"
              :disabled="!pdfDataUrl"
          >
            <v-icon left>mdi-printer</v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import 'jspdf-autotable'
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed"
import jsPDF from "jspdf"

export default {
  name: 'RelatorioFechamentoCombustivel',
  components: { VuePdfEmbed },
  props: {
    titulo: {
      type: String,
      default: '0001 - Fechamento de Despesas de Combustível'
    }
  },
  data() {
    return {
      dialogPreview: false,
      pdfDataUrl: null,
      pdfDoc: null,
      relatorioAtual: null,
      tipoAgrupamentoAtual: 'geral',
      numeroPaginaGlobal: 1,

      // Configurações do relatório
      tituloRelatorio: 'Relatório de Fechamento',

      // Configuração das colunas
      configColunas: [
        { header: 'Empresa', key: 'empresa', width: 15 },
        { header: 'Fornecedor', key: 'fornecedor', width: 20 },
        { header: 'Placa', key: 'placa', width: 12 },
        { header: 'Documento', key: 'documento', width: 15 },
        { header: 'Odômetro', key: 'odometro', type: 'number', decimals: 0, width: 12 },
        { header: 'Data', key: 'dtabastecimento', width: 12, type: 'date' },
        { header: 'Produto', key: 'produto', width: 15 },
        { header: 'Litros', key: 'litros', width: 12, type: 'number', decimals: 2, align: 'right' },
        { header: 'Valor Unit.', key: 'valorunitario', width: 15, type: 'currency', align: 'right' },
        { header: 'Valor Total', key: 'valortotal', width: 15, type: 'currency', align: 'right' }
      ],

      // Configurações do PDF
      configPDF: {
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4',
        margins: { top: 20, left: 5, right: 5, bottom: 15 },
        fontSize: {
          title: 16,
          subtitle: 12,
          table: 8,
          footer: 8,
          total: 10
        }
      }
    }
  },

  methods: {
    async visualizarPDF(dados, orientacao = 'landscape', tipoAgrupamento = 'geral') {
      if (!this.validarDados(dados)) {
        this.emitirEvento('erro', 'Dados inválidos para gerar o relatório')
        return
      }

      if (!this.validarTipoAgrupamento(tipoAgrupamento)) {
        this.emitirEvento('erro', 'Tipo de agrupamento inválido')
        return
      }

      try {
        this.iniciarVisualizacao(dados, orientacao, tipoAgrupamento)
        const doc = await this.gerarPDF(dados, orientacao, tipoAgrupamento)

        if (doc) {
          this.pdfDoc = doc
          this.pdfDataUrl = this.criarDataUrl(doc)
          this.emitirEvento('sucesso', 'Relatório gerado com sucesso!')
        }
      } catch (error) {
        this.tratarErro('Erro ao visualizar PDF', error)
      }
    },

    validarDados(dados) {
      return Array.isArray(dados) && dados.length > 0
    },

    validarTipoAgrupamento(tipoAgrupamento) {
      const tiposValidos = ['geral', 'fornecedor', 'filial', 'produto']
      return tiposValidos.includes(tipoAgrupamento)
    },

    iniciarVisualizacao(dados, orientacao, tipoAgrupamento) {
      this.relatorioAtual = dados
      this.tipoAgrupamentoAtual = tipoAgrupamento
      this.dialogPreview = true
      this.pdfDataUrl = null
      this.configPDF.orientation = orientacao
    },

    async gerarPDF(dados, orientacao, tipoAgrupamento) {
      try {
        const doc = new jsPDF({
          orientation: orientacao,
          unit: this.configPDF.unit,
          format: this.configPDF.format
        })

        // Resetar contador de página
        this.numeroPaginaGlobal = 1

        this.adicionarTitulo(doc, tipoAgrupamento)

        if (tipoAgrupamento === 'geral') {
          this.adicionarTabelaGeral(doc, dados)
        } else {
          this.adicionarTabelasAgrupadas(doc, dados, tipoAgrupamento)
        }

        return doc
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        this.emitirEvento('erro', `Erro ao gerar relatório: ${error.message}`)
        return null
      }
    },

    adicionarTitulo(doc, tipoAgrupamento) {
      const pageWidth = doc.internal.pageSize.getWidth()
      const titulo = this.titulo
      const subtitulo = this.obterSubtitulo(tipoAgrupamento)

      doc.setFontSize(this.configPDF.fontSize.title)
      doc.setFont('helvetica', 'bold')

      const tituloWidth = doc.getTextWidth(titulo)
      const tituloX = (pageWidth - tituloWidth) / 2
      doc.text(titulo, tituloX, 12)

      if (subtitulo) {
        doc.setFontSize(this.configPDF.fontSize.subtitle)
        doc.setFont('helvetica', 'normal')
        const subtituloWidth = doc.getTextWidth(subtitulo)
        const subtituloX = (pageWidth - subtituloWidth) / 2
        doc.text(subtitulo, subtituloX, 18)
      }
    },

    obterSubtitulo(tipoAgrupamento) {
      const subtitulos = {
        'geral': '',
        'fornecedor': 'Agrupado por Fornecedor',
        'filial': 'Agrupado por Filial',
        'produto': 'Agrupado por Produto'
      }
      return subtitulos[tipoAgrupamento] || ''
    },

    adicionarTabelaGeral(doc, dados) {
      const headers = this.configColunas.map(col => col.header)
      const rows = this.prepararDados(dados)

      const tableConfig = {
        head: [headers],
        body: rows,
        startY: this.configPDF.margins.top + 5,
        margin: {
          left: this.configPDF.margins.left,
          right: this.configPDF.margins.right
        },
        styles: {
          fontSize: this.configPDF.fontSize.table,
          cellPadding: 2,
          overflow: 'linebreak',
          halign: 'left'
        },
        headStyles: {
          fillColor: [66, 66, 66],
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'center'
        },
        columnStyles: this.gerarEstilosColunas(),
        didDrawPage: (data) => {
          this.adicionarRodape(doc, data.pageNumber)

          this.numeroPaginaGlobal = data.pageNumber
        }
      }

      doc.autoTable(tableConfig)

      this.adicionarTotalizadorGeral(doc, dados)
    },

    adicionarTabelasAgrupadas(doc, dados, tipoAgrupamento) {
      const dadosAgrupados = this.agruparDados(dados, tipoAgrupamento)
      const headers = this.configColunas.map(col => col.header)

      let startY = this.configPDF.margins.top + 10
      const totaisGerais = { litros: 0, valortotal: 0 }
      let primeiroGrupo = true

      Object.keys(dadosAgrupados).forEach((grupo) => {
        const dadosGrupo = dadosAgrupados[grupo]

        if (!primeiroGrupo && startY > 220) {
          doc.addPage()
          this.numeroPaginaGlobal++
          startY = this.configPDF.margins.top
        }

        // Adicionar título do grupo
        doc.setFontSize(this.configPDF.fontSize.subtitle)
        doc.setFont('helvetica', 'bold')
        doc.text(`${this.obterNomeGrupo(tipoAgrupamento)}: ${grupo}`, this.configPDF.margins.left, startY)
        startY += 8

        // Adicionar tabela do grupo
        const rows = this.prepararDados(dadosGrupo)
        const paginaAtualAntesDaTabela = this.numeroPaginaGlobal

        const tableConfig = {
          head: [headers],
          body: rows,
          startY: startY,
          margin: {
            left: this.configPDF.margins.left,
            right: this.configPDF.margins.right
          },
          styles: {
            fontSize: this.configPDF.fontSize.table,
            cellPadding: 2,
            overflow: 'linebreak',
            halign: 'left'
          },
          headStyles: {
            fillColor: [66, 66, 66],
            textColor: [255, 255, 255],
            fontStyle: 'bold',
            halign: 'center'
          },
          columnStyles: this.gerarEstilosColunas(),
          didDrawPage: (data) => {
            const numeroPaginaAtual = paginaAtualAntesDaTabela + data.pageNumber - 1
            this.adicionarRodape(doc, numeroPaginaAtual)

            if (data.pageNumber > 1) {
              this.numeroPaginaGlobal = numeroPaginaAtual
            }
          }
        }

        doc.autoTable(tableConfig)

        const totalPaginasTabela = doc.getNumberOfPages() - paginaAtualAntesDaTabela + 1
        if (totalPaginasTabela > 1) {
          this.numeroPaginaGlobal = doc.getNumberOfPages()
        }

        // Calcula totais do grupo
        const totaisGrupo = this.calcularTotais(dadosGrupo)
        totaisGerais.litros += totaisGrupo.litros
        totaisGerais.valortotal += totaisGrupo.valortotal

        // Adiciona total do grupo
        startY = doc.lastAutoTable.finalY + 5
        this.adicionarTotalGrupo(doc, totaisGrupo, startY)
        startY += 15

        primeiroGrupo = false
      })

      // Adiciona totalizador geral
      this.adicionarTotalizadorGeral(doc, dados, totaisGerais)
    },

    agruparDados(dados, tipoAgrupamento) {
      const campoAgrupamento = this.obterCampoAgrupamento(tipoAgrupamento)
      const dadosAgrupados = {}

      dados.forEach(item => {
        const chave = item[campoAgrupamento] || 'Não informado'
        if (!dadosAgrupados[chave]) {
          dadosAgrupados[chave] = []
        }
        dadosAgrupados[chave].push(item)
      })

      return dadosAgrupados
    },

    obterCampoAgrupamento(tipoAgrupamento) {
      const campos = {
        'fornecedor': 'fornecedor',
        'filial': 'empresa',
        'produto': 'produto'
      }
      return campos[tipoAgrupamento] || 'fornecedor'
    },

    obterNomeGrupo(tipoAgrupamento) {
      const nomes = {
        'fornecedor': 'Fornecedor',
        'filial': 'Filial',
        'produto': 'Produto'
      }
      return nomes[tipoAgrupamento] || 'Grupo'
    },

    calcularTotais(dados) {
      return dados.reduce((totais, item) => {
        totais.litros += Number(item.litros) || 0
        totais.valortotal += Number(item.valortotal) || 0
        return totais
      }, { litros: 0, valortotal: 0 })
    },

    adicionarTotalGrupo(doc, totais, startY) {
      const pageWidth = doc.internal.pageSize.getWidth()

      doc.setFontSize(this.configPDF.fontSize.total)
      doc.setFont('helvetica', 'bold')

      const textoTotal = `Total do Grupo - Litros: ${this.formatarNumero(totais.litros, 2)} | Valor: ${this.formatarMoeda(totais.valortotal)}`
      const textoWidth = doc.getTextWidth(textoTotal)
      const textoX = pageWidth - textoWidth - this.configPDF.margins.right

      doc.text(textoTotal, textoX, startY)
    },

    adicionarTotalizadorGeral(doc, dados, totaisCalculados = null) {
      const totais = totaisCalculados || this.calcularTotais(dados)
      const pageWidth = doc.internal.pageSize.getWidth()

      let currentY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : doc.internal.pageSize.getHeight() - 40

      if (currentY > doc.internal.pageSize.getHeight() - 30) {
        doc.addPage()
        this.numeroPaginaGlobal++
        currentY = this.configPDF.margins.top
      }

      doc.setFontSize(this.configPDF.fontSize.total + 2)
      doc.setFont('helvetica', 'bold')

      // Linha divisória
      doc.line(this.configPDF.margins.left, currentY, pageWidth - this.configPDF.margins.right, currentY)
      currentY += 8

      const textoTotalGeral = `TOTAL GERAL - Litros: ${this.formatarNumero(totais.litros, 2)} | Valor: ${this.formatarMoeda(totais.valortotal)}`
      const textoWidth = doc.getTextWidth(textoTotalGeral)
      const textoX = (pageWidth - textoWidth) / 2

      doc.text(textoTotalGeral, textoX, currentY)

      // Linha divisória inferior
      currentY += 5
      doc.line(this.configPDF.margins.left, currentY, pageWidth - this.configPDF.margins.right, currentY)

      // Adicionar rodapé na última página se necessário
      this.adicionarRodape(doc, this.numeroPaginaGlobal)
    },

    prepararDados(dados) {
      return dados.map(item =>
          this.configColunas.map(col => this.formatarCampo(item[col.key], col))
      )
    },

    formatarCampo(valor, config) {
      if (!valor && valor !== 0) return ''

      switch (config.type) {
        case 'date':
          return this.formatarData(valor)
        case 'number':
          return this.formatarNumero(valor,config.decimals || 0)
        case 'currency':
          return this.formatarMoeda(valor)
        default:
          return String(valor)
      }
    },

    gerarEstilosColunas() {
      const estilos = {}

      this.configColunas.forEach((col, index) => {
        if (col.align) {
          estilos[index] = { halign: col.align }
        }
      })

      return estilos
    },

    adicionarRodape(doc, numeroPagina) {
      const pageWidth = doc.internal.pageSize.getWidth()
      const pageHeight = doc.internal.pageSize.getHeight()

      doc.setFontSize(this.configPDF.fontSize.footer)
      doc.setFont('helvetica', 'normal')

      const dataAtual = new Date().toLocaleDateString('pt-BR')
      const textoRodape = `Página ${numeroPagina} - Gerado em ${dataAtual}`
      const rodapeWidth = doc.getTextWidth(textoRodape)
      const rodapeX = (pageWidth - rodapeWidth) / 2

      doc.text(textoRodape, rodapeX, pageHeight - 10)
    },

    criarDataUrl(doc) {
      const pdfBlob = doc.output('blob')
      return URL.createObjectURL(pdfBlob)
    },

    async imprimirPDF() {
      if (!this.pdfDoc) {
        this.emitirEvento('erro', 'Nenhum documento para imprimir')
        return
      }

      try {
        const pdfUrl = this.criarDataUrl(this.pdfDoc)
        const printWindow = window.open(pdfUrl, '_blank')

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print()
          }
        } else {
          this.emitirEvento('info', 'Permita pop-ups para imprimir o documento')
        }
      } catch (error) {
        this.tratarErro('Erro ao imprimir PDF', error)
      }
    },

    async baixarPDF() {
      if (!this.pdfDoc || !this.relatorioAtual) {
        this.emitirEvento('erro', 'Nenhum documento para baixar')
        return
      }

      try {
        const sufixo = this.tipoAgrupamentoAtual !== 'geral' ? `_${this.tipoAgrupamentoAtual}` : ''
        const fileName = `fechamento_combustivel${sufixo}_${this.formatarDataArquivo()}.pdf`
        this.pdfDoc.save(fileName)
        this.emitirEvento('sucesso', 'PDF baixado com sucesso!')
      } catch (error) {
        this.tratarErro('Erro ao baixar PDF', error)
      }
    },

    fecharPreview() {
      this.dialogPreview = false
      this.limparRecursos()
    },

    limparRecursos() {
      if (this.pdfDataUrl) {
        URL.revokeObjectURL(this.pdfDataUrl)
        this.pdfDataUrl = null
      }
      this.relatorioAtual = null
      this.pdfDoc = null
      this.tipoAgrupamentoAtual = 'geral'
      this.numeroPaginaGlobal = 1
    },

    emitirEvento(tipo, mensagem) {
      this.$emit(tipo, mensagem)

      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch('showSnackbar', {
          message: mensagem,
          color: tipo === 'erro' ? 'error' : tipo === 'sucesso' ? 'success' : 'info'
        })
      }
    },

    tratarErro(contexto, error) {
      console.error(contexto, error)
      this.emitirEvento('erro', `${contexto}: ${error.message}`)
      this.dialogPreview = false
    }
  },

  beforeDestroy() {
    this.limparRecursos()
  }
}
</script>

<style scoped>
.pdf-container {
  background-color: #f5f5f5;
  border-radius: 4px;
  min-height: 600px;
}

.loading-container {
  height: 600px;
  color: #666;
}

.v-dialog > .v-card > .v-card-title {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.v-dialog > .v-card > .v-card-actions {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

/* Responsividade */
@media (max-width: 768px) {
  .pdf-container {
    min-height: 400px;
  }

  .loading-container {
    height: 400px;
  }
}
</style>